import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import About from './components/About';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Footer from './components/Footer';
import ComingSoonBanner from '../../components/ComingSoonBanner';
import QRCode from '../../components/QRCode';
import SEOHead from '../../components/SEOHead';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const homeSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Fluffy Pets',
    url: SITE_URL,
    description:
      'Professional pet care services including grooming, boarding, veterinary care, and training',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/pets?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'VeterinaryCare',
    name: 'Fluffy Pets',
    url: SITE_URL,
    logo: 'https://static.readdy.ai/image/8ba2fb49baf129fe47398873ffc1b622/7319ff1316bfcbedde225c0cf8d58231.jpeg',
    description:
      'Comprehensive pet care center offering grooming, boarding, veterinary care, and training in San Francisco.',
    telephone: '+15551234567',
    email: 'hello@fluffypets.com',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '123 Pet Care Lane',
      addressLocality: 'San Francisco',
      addressRegion: 'CA',
      postalCode: '94102',
      addressCountry: 'US',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 37.774929,
      longitude: -122.419416,
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '08:00',
        closes: '19:00',
      },
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Saturday'],
        opens: '09:00',
        closes: '18:00',
      },
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Sunday'],
        opens: '10:00',
        closes: '17:00',
      },
    ],
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.9',
      reviewCount: '2500',
      bestRating: '5',
    },
  },
];

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <SEOHead
        title="Fluffy Pets - Professional Pet Care Services | Grooming, Boarding &amp; Veterinary San Francisco"
        description="Fluffy Pets offers professional pet care services including grooming, boarding, veterinary care, and training in San Francisco. Trusted by 10,000+ pet parents. Book your appointment today!"
        keywords="pet care San Francisco, pet grooming, veterinary services, pet boarding, dog training, cat care, pet health, fluffy pets"
        canonical={SITE_URL}
        schema={homeSchema}
        ogImage="https://public.readdy.ai/ai/img_res/a00c118cb466976037329bea3d1cbece.jpg"
      />
      <ComingSoonBanner />
      <Navbar />
      <Hero />
      <Features />
      <About />
      <QRCode />
      <Testimonials />
      <CTA />
      <Footer />
    </div>
  );
}
